import { useEffect, useState } from 'react';

type Activity = {
  wallet: string;
  amount: number;
  time: string;
};

export const useLiveActivity = () => {
  const [activity, setActivity] = useState<Activity[]>([]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    // Generate a random Ethereum address (42 chars: 0x + 40 hex chars)
    const generateEthereumAddress = () => {
      const hex = '0123456789abcdef';
      let address = '0x';
      for (let i = 0; i < 40; i++) {
        address += hex.charAt(Math.floor(Math.random() * hex.length));
      }
      return address;
    };

    const generateActivity = () => {
      const wallet = generateEthereumAddress();
      const shortWallet = `${wallet.slice(0, 6)}...${wallet.slice(-4)}`;
      const amount = +(Math.random() * (12.65 - 0.35) + 0.35).toFixed(2);
      const time = new Date().toLocaleTimeString();

      const newActivity: Activity = { wallet: shortWallet, amount, time };

      setActivity((prev) => [newActivity, ...prev].slice(0, 100));

      const nextInterval = Math.floor(Math.random() * (45000 - 5000 + 1)) + 5000;
      timeout = setTimeout(generateActivity, nextInterval);
    };

    // Delay the initial activity generation
    const initialDelay = Math.floor(Math.random() * (45000 - 5000 + 1)) + 5000;
    timeout = setTimeout(generateActivity, initialDelay);

    return () => clearTimeout(timeout);
  }, []);

  return activity;
};
